var _style, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAwsCostExplorer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0084FF;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 18,
    className: "st0",
    width: 54,
    height: 54
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.7,40.6h-3.1L53.1,42h-2.1l3-8.4h2.4l3,8.4h-2.2L56.7,40.6z M55.2,35.9l-1,3.1h2.1L55.2,35.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.9,33.6h2.2l1.2,6.1l1.5-6.1H67l1.4,6.1l1.2-6.1h2.2L69.7,42h-2.5l-1.3-5.5L64.5,42H62L59.9,33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76,42.1c-1.8,0-3.2-0.9-3.3-2.6h2.2c0.1,0.6,0.5,1,1,1c0.6,0,1-0.3,1-0.8c0-1.6-4.2-0.7-4.2-3.7 c0-1.6,1.3-2.5,3.1-2.5c1.8,0,3.1,0.9,3.2,2.5h-2.2c0-0.5-0.4-0.9-1-0.9c-0.5,0-0.9,0.2-0.9,0.8c0,1.5,4.2,0.8,4.2,3.6 C79.1,40.9,78,42.1,76,42.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62,47.9c2,0,3.5,1.1,4,3h-2.3c-0.3-0.7-1-1.1-1.8-1.1c-1.3,0-2.1,0.9-2.1,2.4s0.9,2.4,2.1,2.4 c0.8,0,1.4-0.4,1.8-1.1H66c-0.5,1.8-2,2.9-4,2.9c-2.5,0-4.2-1.8-4.2-4.3S59.5,47.9,62,47.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.4,49.7h-3.1v1.7H72v1.6h-2.7v1.8h3.1v1.6h-5.2V48h5.2V49.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsCostExplorer);
export default __webpack_public_path__ + "static/media/AWSCostExplorer.eae36403b3db8fa4de45aa2168060238.svg";
export { ForwardRef as ReactComponent };